// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__F4rGH"};